import axios from "axios"


export default () => ({
    open: false,
    axios:null,
    errors:[],
    success:null,
    showButtonToOpenNewsletter:false,
    init() {
        this.axios = axios;
        this.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

        const urlParams = new URLSearchParams(window.location.search);
        const myParam = urlParams.get('pixney');

        if(myParam!==null){
            this.showButtonToOpenNewsletter=true;
        }
    },
    async onSubmitNewsletter() {

        const newsletterFormData = new FormData(this.$refs.mailchimpform)

        // Display the key/value pairs
        // for (var pair of newsletterFormData.entries()) {
        //     console.log(pair[0]+ ', ' + pair[1]);
        // }

        try {
            const response = await this.axios.post(this.$refs.mailchimpform.action, newsletterFormData );
            this.success='You have now signed up to our newsletter.';
            setTimeout(() => {
                this.open=false;
            }, 1000);

        } catch (error) {
            console.log(error.response);
            this.errors='Oops, something went wrong. Please make sure your email is entered correctly.';
            console.log(error.response.status);
        }

    }
})
